import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Spinner, Alert } from 'react-bootstrap';
import './BlogPreview.css';

const BlogPreview = () => {
    const [posts, setPosts] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');

    useEffect(() => {
        const fetchPosts = async () => {
            try {
                const response = await fetch(`${process.env.REACT_APP_API_URL}/blog/posts?limit=3`);
                if (!response.ok) throw new Error('Napaka pri nalaganju blog objav.');
                const data = await response.json();
                setPosts(data.posts || []);
            } catch (err) {
                setError('Ni mogoče naložiti blog objav.');
            } finally {
                setLoading(false);
            }
        };

        fetchPosts();
    }, []);

    if (loading) {
        return <Spinner animation="border" />;
    }

    if (error) {
        return <Alert variant="danger">{error}</Alert>;
    }

    return (
    <section className="blog-section">
      <div className="blog-container">
        <h2 className="blog-title">Naš Blog</h2>
        <div className="blog-line"></div>
        <p className="blog-description">
          Preberite najnovejše nasvete, ideje in zgodbe iz sveta nakupovanja in prodaje rabljenih izdelkov.
        </p>
        <div className="blog-posts">
          {posts.map((post) => (
            <div className="blog-box" key={post.id}>
              <h3>{post.title}</h3>
              <p>{post.meta_description || 'Opis ni na voljo.'}</p>
              <Link to={`/blog/${post.slug}`} className="blog-link">
                Preberi več →
              </Link>
            </div>
          ))}
        </div>
        <div className="blog-footer">
          <Link to="/blog" className="btn-blog">
            Poglej vse objave
          </Link>
        </div>
      </div>
    </section>
  );
};

export default BlogPreview;
